import * as React from 'react';

function SvgHeart(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 23.96 21" focusable={false} role="presentation" aria-hidden={true} {...props}>
      <path d="M17.36-.01a7.33 7.33 0 00-5.35 2.38A7.28 7.28 0 006.59-.01 6.38 6.38 0 00.01 6.15v.13c0 2 .87 3.93 2.81 6.2a74.38 74.38 0 007.42 7l1.77 1.51 1.74-1.5a74.38 74.38 0 007.42-7c1.94-2.27 2.8-4.18 2.8-6.2a6.36 6.36 0 00-6.43-6.3z" />
    </svg>
  );
}

const MemoSvgHeart = React.memo(SvgHeart);
export default MemoSvgHeart;
